const CDN = "https://dcfmv8k1hpguy.cloudfront.net";

export const BG_VIDEOS = {
  bg1: `${CDN}/bg1-small.mp4`,
  bg2: `${CDN}/bg2-small.mp4`,
  bg3: `${CDN}/bg3-small.mp4`,
  bg4: `${CDN}/bg4-small.mp4`,
};
